<div class="p-6">
  <p class="titre2">{{ 'USERS_MANAGEMENT.MOVE_USER' | translate }} - {{data.userName}}</p>

  <mat-select [(ngModel)]="selectedEntite"
    placeholder="{{ 'USERS_MANAGEMENT.SELECT_ENTITY' | translate }}"
    class="w-full border border-gray-300 rounded-md px-3 py-1">
    <mat-option>
      <ngx-mat-select-search [formControl]="entiteFilterCtrl"
        [placeholderLabel]="'USERS_MANAGEMENT.SEARCH' | translate"
        [noEntriesFoundLabel]="'USERS_MANAGEMENT.NO_RESULTS' | translate">
      </ngx-mat-select-search>
    </mat-option>
    @for (entity of filteredEntites | async; track entity) {
      <mat-option [value]="entity.entiteId">
        {{entity.nom}}
      </mat-option>
    }
  </mat-select>

  <div class="flex justify-end gap-4 mt-6">
    <button (click)="onCancel()"
      class="btn-secondary-novo">
      {{ 'USERS_MANAGEMENT.CANCEL' | translate }}
    </button>
    <button (click)="onSave()" [disabled]="!selectedEntite"
      class="btn-primary-novo focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed">
      {{ 'USERS_MANAGEMENT.SAVE' | translate }}
    </button>
  </div>
</div>
